import { getErrorMessage } from "@/utils";
import { useState } from "react";
import { toast } from "react-hot-toast";

import { useAuth } from "../../contexts/AuthContext";
import { useBAACurrentVersion, useBAAStatusData } from "../../hooks/baa";
import { useBAAService } from "../../hooks/baa/useBAAService";
import { useAPI } from "../../hooks/useAPI";
import { BAASignSectionView } from "./BAASignSectionView";

export const BAASignSection = () => {
  const [isAccepting, setIsAccepting] = useState(false);
  const [hasAgreed, setHasAgreed] = useState(false);

  const { firmContext } = useAuth();
  const api = useAPI("v2");
  const baaService = useBAAService(api);
  const { baaVersion } = useBAACurrentVersion();
  const { mutate: mutateBAAStatus } = useBAAStatusData({ enablePolling: false });

  const handleAccept = async () => {
    if (!baaVersion || !hasAgreed || !firmContext?.firmId) return;
    try {
      setIsAccepting(true);
      const response = await baaService.acceptBAA(firmContext.firmId, baaVersion.id);
      if (response.success) {
        await mutateBAAStatus({ needs_signature: false }, false);
        toast.success(response.message);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(getErrorMessage(error));
    } finally {
      setIsAccepting(false);
    }
  };

  return (
    <BAASignSectionView
      isAccepting={isAccepting}
      hasAgreed={hasAgreed}
      onAgreedChange={setHasAgreed}
      onAccept={handleAccept}
    />
  );
};
